import { reduxForm } from 'redux-form'
import Form from '../Components/Form'

import validate from './validate'
import onSubmit from './onSubmit'
import onSubmitFail from './onSubmitFail'

export const FORM_NAME = 'RamsSigning'

const formConfig = {
  form: FORM_NAME,
  initialValues: {},
  validate,
  onSubmit,
  onSubmitFail,
}

export default reduxForm(formConfig)(Form)
